import React, { Component } from 'react';
const d3 = window.d3;
import './styles.css';


class GaugeGraph extends Component {

    componentDidMount() {
        this.renderGraph();
    }
    // Calculation of radius
    deg2rad(deg) {
        return deg * Math.PI / 180;

    }
    // Different range of numbers have different colors
    arcColorFn(value) {
        let ticks = [{
            tick: 0,
            color: '#ff0000'
        }, {
            tick: 25,
            color: '#ffbf00'
        }, {
            tick: 50,
            color: '#ffff00'
        }, {
            tick: 75,
            color: '#00ff00'
        }]
        let ret;
        ticks.forEach(function (tick) {

            if (value > tick.tick) {
                ret = tick.color
                return
            }
        });
        return ret;
    } // arcColorFn


    renderGraph() {
        // set size of the gauge graph
        var size = 200,
            arcInset = 150,
            arcWidth = 60,
            oR = size - arcInset,
            iR = size - oR - arcWidth;

        // Arc defaults
        var arc = d3.arc()
            .innerRadius(iR)
            .outerRadius(oR)
            .startAngle(this.deg2rad(-90));
        // Place svg element into 'this.props.append'
        var svg = d3.select(`.${this.props.append}`).append('svg')
            .attr('class', this.props.className)
            .attr('width', size)
            .attr('height', size)
            .append('g')
            .attr('transform', 'translate(' + size / 2 + ',' + size / 2 + ')');
        // Append background arc to svg
        svg.append('path')
            .datum({ endAngle: this.deg2rad(90) })
            .attr('class', 'gaugeBackground')
            .attr('d', arc);
        // Append foreground arc to svg
        var foreground = svg.append('path')
            .datum({ endAngle: this.deg2rad(-90) })
            .attr('d', arc);
        // Display Max value
        svg.append('text')
            // Set between inner and outer Radius
            .attr('transform', 'translate(' + (iR + ((oR - iR) / 2)) + ',15)')
            .attr('text-anchor', 'middle')
            .text(100);
        // Display Min value
        svg.append('text')
            // Set between inner and outer Radius
            .attr('transform', 'translate(' + -(iR + ((oR - iR) / 2)) + ',15)')
            .attr('text-anchor', 'middle')
            .text(1);
        // Display Current value  
        var current = svg.append('text')
            // Push up from center 1/4 of innerRadius
            .attr('transform', 'translate(0,' + -(-20 + iR / 4) + ')')
            .attr('text-anchor', 'middle')


        // This number get passed in from Dashboard
        var displayNum = this.props.value;

        // Get new color
        var new_color = this.arcColorFn(displayNum);

        var numPi = this.deg2rad(Math.floor(displayNum * 180 / 100 - 90));
        // Display Current value
        current.transition()
            .text(displayNum);

        let cur_color, hold;
        // Arc Transition
        foreground.transition()
            .duration(1000)
            .styleTween('fill', function () {
                return d3.interpolate(new_color, cur_color);
            })
            .call(arcTween, numPi);

        // Set colors for next transition
        hold = cur_color;
        cur_color = new_color;
        new_color = hold;

        // Update animation
        function arcTween(transition, newAngle) {
            transition.attrTween('d', function (d) {
                var interpolate = d3.interpolate(d.endAngle, newAngle);
                return function (t) {
                    d.endAngle = interpolate(t);
                    return arc(d);
                };
            });
        }
    } // renderGraph

    render() {
        return (
            <div>
                <div className={this.props.append}></div>
            </div>
        );
    } //render
}
export default GaugeGraph;


// WEBPACK FOOTER //
// ./src/components/gauge-graph/index.js